export default __webpack_public_path__ + "static/media/60_Random_RotateRight.5deb3d56.mp4";